import React, { useState } from 'react';
import './Birds25.css';

// Import images for fruits
import EagleImage from './images/Eagle.jpg';
import CrowImage from './images/Crow.jpg';
import ParrotImage from './images/Parrot.jpg';
import OstrichImage from './images/Ostrich.jpg';
import DuckImage from './images/Duck.jpg';
import OwlImage from './images/Owl.jpg';
import peacockImage from './images/peacock.jpg';
import HummingbirdImage from './images/Hummingbird.jpg';
import PenguinImage from './images/Penguin.jpg';
import GooseImage from './images/Goose.jpg';

import SparrowImage from './images/Sparrow.jpg';
import FlamingoImage from './images/Flamingo.jpg';
import PegionImage from './images/Pegion.jpg';
import DoveImage from './images/Dove.jpg';
import WeaverBirdImage from './images/WeaverBird.jpg';
import SwanImnage from './images/Swan.jpg';

const fruits = [
  { name: 'Eagle', image: EagleImage },
  { name: 'Crow', image: CrowImage },
  { name: 'Parrot', image: ParrotImage },
  { name: 'Ostrich', image: OstrichImage },
  { name: 'Duck', image: DuckImage },
  { name: 'Owl', image: OwlImage },
  { name: 'Peacock', image: peacockImage },
  { name: 'Humming Bird', image: HummingbirdImage },
  { name: 'Penguin', image: PenguinImage },
  { name: 'Goose', image: GooseImage },

  { name: 'Sparrow', image: SparrowImage },
  { name: 'Flamingo', image: FlamingoImage },
  { name: 'Pegion', image: PegionImage },
  { name: 'Dove', image: DoveImage },
  { name: 'Weaver Bird', image: WeaverBirdImage },
  { name: 'Swan', image: SwanImnage }
];

const Birds25 = () => {
  const [selectedFruit, setSelectedFruit] = useState(null);
  const [quizFruit, setQuizFruit] = useState(null);
  const [quizAnswer, setQuizAnswer] = useState('');
  const [quizResult, setQuizResult] = useState('');

  const speakFruit = (fruitName) => {
    const utterance = new SpeechSynthesisUtterance(fruitName);
    window.speechSynthesis.speak(utterance);
  };

  const handleFruitClick = (fruit) => {
    setSelectedFruit(fruit);
    speakFruit(fruit.name);
  };

  const startQuiz = () => {
    const randomFruit = fruits[Math.floor(Math.random() * fruits.length)];
    setQuizFruit(randomFruit);
    setQuizAnswer('');
    setQuizResult('');
  };

  const submitQuiz = () => {
    if (quizAnswer.toLowerCase() === quizFruit.name.toLowerCase()) {
      setQuizResult('Correct!');
    } else {
      setQuizResult(`Wrong! The correct Bird was ${quizFruit.name}`);
    }
  };

  const clearQuiz = () => {
    setQuizFruit(null);
    setQuizAnswer('');
    setQuizResult('');
  };

  const nextQuiz = () => {
    startQuiz();
  };

  return (
    <div className="AppFruits">
      <h1>Birds</h1>
      <div className="fruits">
        {fruits.map((fruit) => (
          <div
            key={fruit.name}
            className="fruit-box"
            onClick={() => handleFruitClick(fruit)}
          >
            <img src={fruit.image} alt={fruit.name} className="fruit-image" />
            <p>{fruit.name}</p>
          </div>
        ))}
      </div>
      {selectedFruit && <div className="selected-fruit">You selected: {selectedFruit.name}</div>}
      <div className="quiz-section">
        <h2>Quiz Mode</h2>
        {quizFruit ? (
          <div>
            <p>Which Bird is this?</p>
            <img src={quizFruit.image} alt="Quiz Bird" className="quiz-image" />
            <input
              type="text"
              value={quizAnswer}
              onChange={(e) => setQuizAnswer(e.target.value)}
              placeholder="Enter Bird name"
            />
            <button onClick={submitQuiz}>Submit</button>
            <button onClick={nextQuiz}>Next Bird</button>
            <button onClick={clearQuiz}>Clear</button>
            {quizResult && <p>{quizResult}</p>}
          </div>
        ) : (
          <button onClick={startQuiz}>Start Quiz</button>
        )}
      </div>
    </div>
  );
};

export default Birds25;



